import { SUPABASE_CONFIG } from '../config/supabase';

export interface CreditsBalance {
  total_credits: number;
  one_time_credits: number;
  subscription_credits: number;
  has_credits: boolean;
}

export interface DeductResult {
  status: 'success' | 'error';
  message: string;
  previous_credits?: number;
  new_credits?: number;
  credits_deducted?: number;
  error?: string;
  credits_available?: number;
  credits_needed?: number;
}

/**
 * Check if user has available credits
 */
export const checkCredits = async (userId: string): Promise<CreditsBalance> => {
  try {
    // Add timestamp to prevent caching
    const cacheBuster = Date.now();
    const response = await fetch(
      `${SUPABASE_CONFIG.url}/functions/v1/check-credits?user_id=${encodeURIComponent(userId)}&_cb=${cacheBuster}`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${SUPABASE_CONFIG.anonKey}`,
          'Content-Type': 'application/json',
        },
      }
    );

    const data = await response.json();

    if (data.status === 'error') {
      throw new Error(data.error);
    }

    return {
      total_credits: data.total_credits,
      one_time_credits: data.one_time_credits,
      subscription_credits: data.subscription_credits,
      has_credits: data.has_credits,
    };
  } catch (error) {
    console.error('Error checking credits:', error);
    throw error;
  }
};

/**
 * Deduct credits from user's balance
 */
export const deductCredit = async (
  userId: string,
  creditsToDeduct: number = 1
): Promise<DeductResult> => {
  try {
    const response = await fetch(
      `${SUPABASE_CONFIG.url}/functions/v1/deduct-credit`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${SUPABASE_CONFIG.anonKey}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          credits_to_deduct: creditsToDeduct,
        }),
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error deducting credit:', error);
    throw error;
  }
};

